const DataPortofolio = [
    {
        id: 1,
        judul: "Landing Page Nadazkia",
        cover: "img/portfolio/1.png",
        altCover: "Port1",
        deskripsi: "Dibuat dengan menggunakan Tailwind CSS dan ReactJS",
        link: "https://nadazkia.github.io",
    },
    {
        id: 2,
        judul: "Landing Page Nada Fatiyyah Azkia",
        cover: "img/portfolio/1.png",
        altCover: "Port2",
        deskripsi: "Dibuat dengan menggunakan Tailwind CSS dan ReactJS",
        link: "#",
    }
]

export default DataPortofolio